<template lang="pug">
  div
    section.content-header
      h1 修正サービスの設定
      ol.breadcrumb
        li
          router-link(:to="{name: 'admin'}")
            i.fa.fa-cog
            | システム管理
        li.active 修正サービスの設定

    section.content
      app-messages(:errorMessages="errors", :successMessages="successes")

      form(@submit.prevent="postData")
        mixin btnbar
          .row.bcard-btnbar(class!=attributes.class)
            .col-sm-6
              button.btn.btn-primary(:disabled="isLoading" type="submit") 変更
              |
              |
              router-link(:to="{name: 'admin'}")
                button.btn.btn-default キャンセル
        +btnbar

        .box.box-widget
          .box-body
            .form-group
              label.control-label 「修正サービスの利用」の初期選択肢
              .radio.radio-rich
                label
                  input(type="radio" name="default_input_proxy" :value="app_flag.ON" v-model="default_input_proxy")
                  span: i.fa.fa-dot-circle-o.fa-lg
                  | &nbsp;「する」を初期選択する

                label
                  input(type="radio" name="default_input_proxy" :value="app_flag.OFF" v-model="default_input_proxy")
                  span: i.fa.fa-dot-circle-o.fa-lg
                  | &nbsp;「しない」を初期選択する

              .help-block
                p.bcard-comments.text-info
                  | ※ この設定は「画像からの登録」画面に反映されます（ScanSnapは除く）。
                p.bcard-comments.text-info
                  | ※ ユーザーが自分で選択を変更することもできます。

        +btnbar(class="-bottom")

</template>

<script>
import AppMessages from '@/components/molecules/AppMessages'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const InputProxySettingsRepository = RepositoryFactory.get('inputproxysettings')

export default {
  name: 'InputProxySettings',
  components: { AppMessages },
  data () {
    return {
      default_input_proxy: '0', // app_flag.OFF
      isLoading: true // 読み込み中かどうか
    }
  },
  computed: {
    /**
     * ライセンス情報取得
     * @return bool
     */
    use_agency () {
      const license = this.$store.getState('license')
      return (this.$store.state.base.u && license && license.contract_input) || false
    }
  },
  created () {
    // サイドメニューでこのページへのリンクを隠しているのときは、このページを表示させない
    if (!this.use_agency) {
      this.$router.push({name: 'page-unlicensed'})
    }

    // 設定値を取得する
    const vm = this
    InputProxySettingsRepository.get()
      .then(function (response) {
        const data = vm.getApiData(response).data
        vm.default_input_proxy = data.default_input_proxy
        vm.isLoading = false
      })
      .catch(function (error) {
        vm.setErrorMessage(error)
      })
  },
  methods: {
    // 設定値を更新する
    postData () {
      const vm = this

      // パラメータ
      const data = {
        default_input_proxy: this.default_input_proxy
      }

      // API実行
      InputProxySettingsRepository.put(data)
        .then(function () {
        // 成功時は設定状況に遷移
          vm.$router.push({name: 'admin'})
        }).catch(function (error) {
          // エラー時はメッセージを表示
          scrollTo(0, 0)
          vm.setErrorMessage(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/envsettings/InputProxySettings.vue